var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8849 112.05C70.5291 111.895 72.3017 112.05 73.9616 112.05L84.0227 112.051C85.7011 112.052 87.3913 112.127 89.0673 112.05C88.5362 115.054 88.6476 118.187 89.0673 121.198L75.2182 121.202C73.1343 121.197 70.9522 120.962 68.8849 121.198C69.2734 117.6 69.1157 115.698 68.8849 112.05Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8849 35.0359L82.8386 35.0375C84.983 35.0359 87.2027 34.8819 89.3363 35.0359C88.2078 37.9802 89.4595 44.693 89.3363 44.9782C88.0705 45.035 86.7809 44.9816 85.5123 44.9813L72.7547 44.9788C71.6823 44.9782 69.2 45.351 68.8849 44.3761C68.9297 40.8767 69.7212 39.0683 68.8849 35.0359Z",
    fill: "#B2B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3611 61.4209C46.8334 61.8375 49.591 61.7144 53.0037 60.8901V73.7764L59.4719 73.8051C59.9959 73.8106 60.5347 73.7539 61.0534 73.7764L61.0479 80.1235C61.0466 81.153 60.9735 82.2279 61.0534 83.2518C58.1866 83.2502 54.9902 83.5135 52.2258 82.6408C47.7299 81.2212 44.3218 77.419 43.4015 72.8052C43.0519 71.0527 42.9084 62.8494 43.3611 61.4209Z",
    fill: "#B2B2B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5207 73.7765C102.639 73.4231 107.103 73.5793 110.373 76.336C115.064 80.29 114.802 84.6183 114.799 90.0786C114.799 91.765 114.861 93.4771 114.798 95.1599C111.517 94.6979 108.496 94.8661 105.245 95.4478C105.17 92.888 105.599 87.1207 105.059 85.0898C104.353 82.4325 100.172 83.2451 98.184 83.2519C97.8711 83.2577 97.1481 83.1411 96.9333 83.4095C97.0012 82.3418 96.9395 81.242 96.9383 80.1705L96.9333 73.7765C97.4582 73.7722 97.9977 73.7431 98.5207 73.7765Z",
    fill: "#B2B2B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9333 73.7764C97.4582 73.7721 97.9977 73.7431 98.5207 73.7764L98.5417 73.8925C98.2813 73.9718 98.0282 73.9548 97.7582 73.9508C97.4604 75.4212 96.6577 82.7559 98.4933 83.1645L98.184 83.2518C97.8711 83.2577 97.1481 83.141 96.9333 83.4095C97.0012 82.3418 96.9395 81.2419 96.9383 80.1705L96.9333 73.7764Z",
    fill: "#B2B2B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7866 61.0442C75.8622 61.1349 79.9613 61.0405 84.0393 61.0389C87.8391 61.0377 91.8255 60.4436 94.6969 63.4774C97.4987 66.4381 96.6596 70.1572 96.9333 73.7764L96.9383 80.1705C96.9395 81.2419 97.0012 82.3418 96.9333 83.4095C96.954 89.5882 95.8205 95.7366 88.2449 95.8884C83.7122 95.9791 79.1614 95.8977 74.6272 95.8964L70.5492 95.8952C67.799 95.8949 65.7678 95.7934 63.653 93.739C60.5171 90.6923 61.0908 87.2268 61.0534 83.2518C60.9735 82.2279 61.0466 81.153 61.0479 80.1236L61.0534 73.7764C61.0253 64.7692 61.9073 61.0528 71.7866 61.0442Z",
    fill: "url(#paint0_linear_241_2704)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0534 73.7765C61.0253 64.7692 61.9073 61.0528 71.7866 61.0442L71.74 61.154C72.1545 61.4194 72.7717 61.2368 73.1762 61.6305L73.0759 62.0903C73.8431 62.8988 72.5772 63.0238 72.3557 63.833C72.1514 64.5782 70.2637 66.4372 69.5212 67.1673C67.5577 69.0991 66.7004 69.4898 65.0198 72.186C64.5751 72.8991 64.2159 73.8697 63.5987 74.4338C59.4389 78.2356 61.761 78.5362 61.0534 83.2518C60.9735 82.2279 61.0466 81.1531 61.0479 80.1236L61.0534 73.7765Z",
    fill: "#F5C754"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8849 121.198C67.2889 128.622 62.714 134.789 55.5543 137.795C35.8435 146.07 17.112 123.114 28.879 104.911C36.0413 93.8316 51.2389 91.5224 61.2321 99.8936C65.8721 103.78 66.7976 106.706 68.8849 112.05C69.1157 115.698 69.2734 117.6 68.8849 121.198Z",
    fill: "url(#paint1_linear_241_2704)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3611 61.4209C40.0983 60.5788 37.3259 59.7156 34.5588 57.7073C24.0945 50.1122 22.1875 36.3647 29.7925 25.9822C41.0439 10.6213 66.193 17.0144 68.8849 35.0358C69.7212 39.0682 68.9296 40.8766 68.8849 44.3761C67.0003 51.179 60.3992 59.7622 53.0037 60.8901C49.591 61.7144 46.8334 61.8375 43.3611 61.4209Z",
    fill: "url(#paint2_linear_241_2704)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3364 35.0359C89.7418 33.6868 89.9628 32.3691 90.4973 31.0461C97.3971 13.9721 121.704 12.3968 130.497 29.0896C139.487 46.1573 123.419 66.8699 104.336 60.7458C97.5227 58.5597 91.8644 52.9939 89.8156 46.1132C89.7341 45.8392 89.64 45.1828 89.4246 45.0066L89.3364 44.9782C89.4595 44.6931 88.2078 37.9802 89.3364 35.0359Z",
    fill: "url(#paint3_linear_241_2704)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M105.245 95.4478C108.496 94.8661 111.517 94.6979 114.798 95.1599C116.316 95.5543 117.812 95.9496 119.268 96.543C129.411 100.676 135.15 112.132 132.39 122.745C126.692 144.66 96.2152 144.587 89.7283 123.706C89.4709 122.878 89.3061 122.029 89.0673 121.198C88.6476 118.187 88.5362 115.054 89.0673 112.05C89.308 111.475 89.4524 110.827 89.6422 110.231C92.2226 102.126 97.5937 97.9496 105.245 95.4478Z",
    fill: "url(#paint4_linear_241_2704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_2704",
    x1: 94.5589,
    y1: 92.7727,
    x2: 67.0231,
    y2: 67.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_2704",
    x1: 63.1728,
    y1: 132.095,
    x2: 31.3196,
    y2: 102.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F1F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_241_2704",
    x1: 63.544,
    y1: 53.9971,
    x2: 30.9101,
    y2: 24.7851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F1F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_241_2704",
    x1: 127.47,
    y1: 53.8917,
    x2: 94.3646,
    y2: 25.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F1F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_241_2704",
    x1: 127.352,
    y1: 131.878,
    x2: 94.3398,
    y2: 102.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFA",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F1F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataPlaceholder);
export default __webpack_public_path__ + "static/media/no-data-placeholder.92dee97d01f4990f46eefd84c0ccfab0.svg";
export { ForwardRef as ReactComponent };